import { AppModalDialogBox } from "../../../../components/modals";
import { Box, Button, Typography, Chip } from "@mui/material";
import { Quiz, Business, QuestionAnswer } from "@mui/icons-material";

export default function AmbassadorAnswersModal({
  onClose,
  questions,
  clientDetails,
}) {
  const hasQuestions = questions && Object.keys(questions).length > 0;
  const hasCompanyInfo = clientDetails?.other_info;

  return (
    <AppModalDialogBox
      isModalOpen={true}
      title="Answers"
      handleClose={onClose}
      size={"md"}
      actionButtonRenderer={<Button onClick={onClose}>Close</Button>}
    >
      <Box sx={styles.modalContent}>
        {/* Company Information Section */}
        {hasCompanyInfo && (
          <Box sx={styles.companyInfoSection}>
            <Box sx={styles.companyInfoHeader}>
              <Business sx={styles.companyInfoIcon} />
              <Typography sx={styles.companyInfoTitle}>
                Company/product offering/value prop:
              </Typography>
            </Box>
            <Typography sx={styles.companyInfoValue}>
              {clientDetails?.other_info}
            </Typography>
          </Box>
        )}

        {/* Questions and Answers Section */}
        {hasQuestions ? (
          <Box sx={styles.questionsContainer}>
            <Box sx={styles.sectionHeader}>
              <QuestionAnswer sx={styles.sectionIcon} />
              <Typography sx={styles.sectionTitle}>Q&A Responses</Typography>
              <Chip
                label={`${Object.keys(questions).length} Questions`}
                size="small"
                sx={styles.questionCountChip}
              />
            </Box>

            <Box>
              {Object.keys(questions).map((que, index) => (
                <Box key={`question-${index}`} sx={styles.questionItem} gap={2}>
                  <Box sx={styles.questionNumber}>{index + 1}</Box>
                  <Box sx={styles.questionContent}>
                    <Typography sx={styles.questionText}>
                      {questions?.[que]?.q?.question}
                    </Typography>
                    <Typography sx={styles.answerText}>
                      {questions?.[que]?.a || "No response provided"}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          <Box sx={styles.noDataContainer}>
            <Quiz sx={styles.noDataIcon} />
            <Typography sx={styles.noDataText}>
              No questions and answers available
            </Typography>
          </Box>
        )}
      </Box>
    </AppModalDialogBox>
  );
}

const styles = {
  modalContent: {
    p: 1,
  },
  companyInfoSection: {
    mb: 2,
    borderRadius: 2,
  },
  companyInfoHeader: {
    display: "flex",
    alignItems: "center",
    mb: 0.5,
  },
  companyInfoIcon: {
    mr: 0.5,
    color: "primary.main",
    fontSize: 14,
  },
  companyInfoTitle: {
    color: "primary.main",
    fontWeight: 600,
    fontSize: 14,
  },
  companyInfoValue: {
    color: "text.primary",
    fontSize: 11,
    lineHeight: 1.3,
    ml: 2,
  },
  questionsContainer: {
    mb: 2,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    pb: 0.5,
    borderBottom: "1px solid #e0e0e0",
  },
  sectionIcon: {
    mr: 0.5,
    color: "primary.main",
    fontSize: 14,
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: "text.primary",
  },
  questionCountChip: {
    ml: 1,
    backgroundColor: "primary.main",
    color: "white",
    fontSize: 9,
    height: 18,
  },
  questionItem: {
    display: "flex",
    alignItems: "flex-start",
    mb: 2,
  },
  questionNumber: {
    minWidth: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: "primary.main",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    flexShrink: 0,
  },
  questionContent: {
    flex: 1,
    minWidth: 0,
  },
  questionText: {
    color: "text.primary",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.3,
    mb: 0.5,
  },
  answerText: {
    color: "text.secondary",
    fontSize: 12,
    lineHeight: 1.3,
  },
  noDataContainer: {
    textAlign: "center",
    py: 2,
  },
  noDataIcon: {
    fontSize: 24,
    color: "text.secondary",
    mb: 1,
  },
  noDataText: {
    color: "text.secondary",
    fontSize: 11,
  },
  closeButton: {
    minWidth: 80,
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 11,
  },
};
